import React, { FC } from 'react';

import { Tabs, TabsList, TabsTrigger, cn } from '@column/ui';

export interface StateTabEntry {
  label: React.ReactNode;
  value: string;
  hide?: boolean;
}

interface StateTabsProps {
  value: string;
  onValueChange: (value: string) => void;
  entries: StateTabEntry[];
  className?: string;
}

export const StateTabs: FC<StateTabsProps> = ({ value, onValueChange, entries, className }) => {
  const visible = entries.filter((e) => !e.hide);

  if (!visible.length) return null;

  return (
    <Tabs
      value={value}
      onValueChange={onValueChange}
      className={cn(
        'px-3 py-0.5 shadow-[0_1px_0_0_color-mix(in_oklch,var(--color-gray-950)_8%,transparent)] bg-gray-25 sticky top-0 -mt-px z-10',
        className
      )}
    >
      <TabsList variant="ghost" className="gap-0.5">
        {visible.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
